import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { initialState } from './state';
import {
    setClientWidth,
    setClientHeight,
    setWebviewOs,
    setClientOffsetTop,
    setTabVisibility,
    setWebviewTheme,
} from './actions';

export const reducer = reducerWithInitialState(initialState)
    .case(setClientWidth, (state, payload) => ({
        ...state,
        width: payload,
    }))
    .case(setClientHeight, (state, payload) => ({
        ...state,
        height: payload,
    }))
    .case(setWebviewOs, (state, payload) => ({
        ...state,
        webviewOs: payload,
    }))
    .case(setClientOffsetTop, (state, payload) => ({
        ...state,
        offsetTop: payload,
    }))
    .case(setTabVisibility, (state, payload) => ({
        ...state,
        tabVisible: payload,
    }))
    .case(setWebviewTheme, (state, payload) => ({
        ...state,
        webviewTheme: payload,
    }));

export default reducer;
